import { motion } from "framer-motion";
import { STATS } from "@/data/site";

export default function Stats() {
  return (
    <section id="stats" className="relative py-24 lg:py-32" data-testid="stats-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.5 }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="bg-[#050505] p-8 lg:p-12"
              data-testid={`stat-${i}`}
            >
              <div className="font-display text-5xl lg:text-6xl text-gradient-gold">{s.value}</div>
              <div className="mt-3 font-mono text-[11px] tracking-[0.2em] uppercase text-[#A3A3A3]">{s.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
